<template>
  <div class="md-form">
    <i class="fa prefix" v-bind:class="[data.icon]"></i>
    <input v-if="type === 'password'" type="password" v-model="data.value" :id="data.name" class="form-control" v-bind:class="{invalid: data.errors.length}">
    <input v-if="type === 'text'" type="text" v-model="data.value" :id="data.name" class="form-control" v-bind:class="{invalid: data.errors.length}" :disabled="data.disabled === true ? true : false">
    <label :for="data.name" v-bind:class="{disabled: data.disabled, active: data.value}">{{t(data.label)}}</label>
    <div v-if="data.help" class="helpterText">
      {{t(data.help)}}
    </div>
    <div v-if="data.errors.length" class="validationErrors">
      <small v-for="error in data.errors">
        {{t(error)}}
      </small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'textInput',
  data() {
    return {

    };
  },
  props: {
    data: {},
    type: {
      default: 'text',
    },
  },
  computed: {
    model() {
      return this.data.name;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../static/MDB-PRO/sass/mdb/free/data/colors"; 
@import "../../assets/scss/variables"; 
.prefix {
  position: absolute;
  left: 0;
  font-size: 22px;
  color: rgba(255,255,255, 0.6);
}
.prefix.active {
  color: rgba(255,255,255, 1);
}

input {
  color: white;
}
label {
  color: rgba(255, 255, 255, 0.7);
}
input[disabled], input[disabled]+label {
  color: lighten($primary-color, 5%); 
}
input[type=text]:focus:not([readonly]) + label {
  color: white;
}
input[type=text]:focus:not([readonly]) {
  color: white;
  border-bottom: 1px solid white;
  box-shadow: 0 1px 0 0 rgba(255,255,255, 0.4);
}

.helpterText {
  font-size: 0.9rem;
  margin-top: -12px;
  text-align: right;
  opacity: 0.9;
  padding-right: 6px;
}

</style>



// WEBPACK FOOTER //
// TextInputSearchBar.vue?4530287a